/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
var encrypter = require("object-encrypter")
var engine = encrypter("wakari1CH1maksue", { ttl: true })
import _ from 'lodash'
export const ASYNC_KEY = {
    IS_LOGIN: 'is_login',
    ACCESS_TOKEN: 'access_token',
    USER: 'login_user',   
  };
  

export const jnDecrypt = async encryptedObj => {
  console.log(">>> encryptedObj" , encryptedObj)
  if(encryptedObj!=undefined)
  try{
    return await engine.decrypt(encryptedObj);  
  }  catch(e){

  }
    
};

  /***
 * Functions
 */
export const jnEncrypt = async obj => {
  //7 days localStorage expired
  return engine.encrypt(obj, 7 * 24 * 60 * 60 * 1000);
};

export const currencyFormat = (value) => {
  if(value == undefined) value = 0
  return parseFloat(value).toLocaleString('en-US', {minimumFractionDigits: 2}) 
}

export const phoneFormat = (receiver) => {    
  return `(${_.get(receiver, 'countryCode') ? _.get(receiver, 'countryCode') : ''}) ${_.get(receiver, 'phone') ? _.get(receiver, 'phone') : ''}`
}

export const nameFormat = (receiver) => {  
  console.log(receiver)
  const firstName = receiver.firstName ?? ''
  const lastName = receiver.lastName ?? ''
  return firstName.capitalize() + ' ' + lastName.capitalize() 
}

String.prototype.capitalize = function() {
  if(this == null) return ''
  return this.charAt(0).toUpperCase() + this.slice(1);
}